export default function MonitoringIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3333 2.29175H1.66666C1.32499 2.29175 1.04166 2.00841 1.04166 1.66675C1.04166 1.32508 1.32499 1.04175 1.66666 1.04175H18.3333C18.675 1.04175 18.9583 1.32508 18.9583 1.66675C18.9583 2.00841 18.675 2.29175 18.3333 2.29175Z"
        fill="white"
      />
      <path
        d="M13.8917 18.6167C13.7833 18.8334 13.5583 18.9584 13.3333 18.9584C13.2417 18.9584 13.1417 18.9334 13.0583 18.8917L10 17.3667L6.94167 18.8917C6.85833 18.9334 6.75833 18.9584 6.66667 18.9584C6.44167 18.9584 6.21667 18.8334 6.10833 18.6167C5.95 18.3001 6.075 17.9251 6.39167 17.7751L9.375 16.2834V14.1667H10.625V16.2834L13.6083 17.7751C13.925 17.9251 14.05 18.3001 13.8917 18.6167Z"
        fill="white"
      />
      <path
        d="M2.5 1.66675V11.7501C2.5 13.3334 3.33333 14.1667 4.91667 14.1667H15.0833C16.6667 14.1667 17.5 13.3334 17.5 11.7501V1.66675H2.5ZM14.15 7.15008L11.525 9.34175C11.2833 9.54175 10.975 9.62508 10.6833 9.57508C10.3833 9.52508 10.125 9.34175 9.96667 9.07508L9.09167 7.61675L6.65 9.65008C6.53333 9.75008 6.39167 9.79175 6.25 9.79175C6.075 9.79175 5.89167 9.71675 5.76667 9.56675C5.54167 9.30008 5.58333 8.90841 5.85 8.68341L8.475 6.49175C8.71667 6.29175 9.025 6.20842 9.31667 6.25841C9.61667 6.30841 9.875 6.49175 10.0333 6.75841L10.9083 8.21675L13.35 6.18341C13.6167 5.95841 14.0083 6.00008 14.2333 6.26675C14.45 6.53341 14.4167 6.92508 14.15 7.15008Z"
        fill="white"
      />
    </svg>
  );
}
